import { Link } from 'react-router-dom';

import AddIcon from '~/shared/assets/add.icon.svg';
import { navigationLinks } from '~/shared/config/navigation-links';
import { routes } from '~/shared/config/routes';
import { Button } from '~/shared/ui/button';

import { NavigationButton } from './NavigationButton';

export function SideBarWidget() {
  // TODO Add logic that switch between admin & teacher
  const links = navigationLinks.get('teacher') ?? [];

  return (
    <nav className="hidden w-48 flex-col gap-8 md:flex">
      <Link to={routes.dashboard.courses.create.get()}>
        <Button width="full" justify="start">
          Create new course
          <AddIcon />
        </Button>
      </Link>

      <section>
        {links.map((linkProperties) => (
          <NavigationButton key={linkProperties.linkText} {...linkProperties} />
        ))}
      </section>
    </nav>
  );
}
